'use client'

import { useCallback } from 'react'
import { formatMoney, getCurrencySymbol, shouldShowCurrencyCode } from './format'

export function useMoney(defaultCurrency = 'MXN', locale = 'es-MX') {
  const money = useCallback(
    (value: number, currency?: string) => {
      return formatMoney(value, currency || defaultCurrency, locale)
    },
    [defaultCurrency, locale]
  )

  const symbol = useCallback(
    (currency?: string) => {
      return getCurrencySymbol(currency || defaultCurrency, locale)
    },
    [defaultCurrency, locale]
  )

  const showCode = useCallback((currency?: string) => {
    return shouldShowCurrencyCode(currency || defaultCurrency)
  }, [defaultCurrency])

  return {
    money,
    symbol,
    showCode,
  }
}